export default "__VITE_ASSET__wbcR1HYe__"